var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.isUploading
    },
    on: {
      "update:active": function($event) {
        _vm.isUploading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.hubLoading
    },
    on: {
      "update:active": function($event) {
        _vm.hubLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.hubList,
      "name": "location_id",
      "id": "location_id",
      "placeholder": "Select Hub",
      "label": "location_with_id",
      "track-by": "location_id",
      "optionHeight": 100
    },
    model: {
      value: (_vm.hub),
      callback: function($$v) {
        _vm.hub = $$v
      },
      expression: "hub"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.importCSvModal()
      }
    }
  }, [_vm._v(" ImportCSV")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-end ms-auto"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-info",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.exportCSV()
      }
    }
  }, [_vm._v(" ExportCSV")])])])])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myCommentModalRef",
    attrs: {
      "id": "modal-md",
      "size": "md",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.importCSVModalShow),
      callback: function($$v) {
        _vm.importCSVModalShow = $$v
      },
      expression: "importCSVModalShow"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.isUploading
    },
    on: {
      "update:active": function($event) {
        _vm.isUploading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Import CSV")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "fileInput",
      "accept": ".csv"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("Upload CSV")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('span', [_c('a', {
    staticStyle: {
      "color": "blue",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.generateCSV()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Sample CSV")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  })])])], 1), _vm._v(" "), _c('b-modal', {
    ref: "myCommentModalRef",
    attrs: {
      "id": "modal-sm",
      "size": "md",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.importDataStatus),
      callback: function($$v) {
        _vm.importDataStatus = $$v
      },
      expression: "importDataStatus"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Import data status")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.responseData.exists > 0) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.responseData.exists))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Data already exists..!!!")])]) : _vm._e(), _vm._v(" "), (_vm.responseData.notexists > 0) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.responseData.notexists))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("Data uploaded successfully..!!!")])]) : _vm._e()])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "myCommentModalRef",
    attrs: {
      "id": "modal-lg",
      "size": "lg",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.commentModalShow),
      callback: function($$v) {
        _vm.commentModalShow = $$v
      },
      expression: "commentModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(" Edit Locations data")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Zone Name ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "zoneName",
      "type": "text",
      "name": "zoneName",
      "disabled": ""
    },
    model: {
      value: (_vm.zoneName),
      callback: function($$v) {
        _vm.zoneName = $$v
      },
      expression: "zoneName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Location Type")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "locationType",
      "type": "text",
      "name": "locationType",
      "disabled": ""
    },
    model: {
      value: (_vm.locationType),
      callback: function($$v) {
        _vm.locationType = $$v
      },
      expression: "locationType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Location ")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "locationName",
      "type": "text",
      "name": "locationName",
      "disabled": ""
    },
    model: {
      value: (_vm.locationName),
      callback: function($$v) {
        _vm.locationName = $$v
      },
      expression: "locationName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("RM Email")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editRMEmail),
      expression: "editRMEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "editRMEmail",
      "type": "text",
      "name": "editRMEmail"
    },
    domProps: {
      "value": (_vm.editRMEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editRMEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.isValidEmail(_vm.editRMEmail)) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Invalid email format")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("State Email")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editStateEmail),
      expression: "editStateEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "editStateEmail",
      "type": "text",
      "name": "editStateEmail"
    },
    domProps: {
      "value": (_vm.editStateEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editStateEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.isValidEmail(_vm.editStateEmail)) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Invalid email format")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("Cluster Email")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editClusterEmail),
      expression: "editClusterEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "editClusterEmail",
      "type": "text",
      "name": "editClusterEmail"
    },
    domProps: {
      "value": (_vm.editClusterEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editClusterEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.isValidEmail(_vm.editClusterEmail)) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Invalid email format")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('label', [_vm._v("isActive")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.editStatus
    },
    on: {
      "click": function($event) {
        _vm.editStatus = !_vm.editStatus
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slider round"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.updateEmail()
      }
    }
  }, [_vm._v(" Update")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "close"
    },
    on: {
      "click": _vm.closeStatusRoleModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Close")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "currentSelection"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.getLocationData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getLocationData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v(_vm._s(_vm.pageno + index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editSelectedDetails(data)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.zone.zone_name || '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.location_name) + " - " + _vm._s(data.location_id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.zone.rm_email || '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.state.state_email || '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.cluster.cluster_email || '-'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.isactive ? 'True' : 'False') + " ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.location_type || '-'))])])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.resultCount > 0) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '«',
      "next-text": '»',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-filter filter"
  }), _vm._v(" Search")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "header"
  }, [_vm._v("\n              Location details\n            ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Zone")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Location Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("RM Email")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("State Head Email")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Cluster Head Email")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("isActive")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Location Type")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24d96459","hasScoped":true}!./src/views/components/emailConfig/emailConfig.component.html
// module id = 782
// module chunks = 1